<template>
  <div :class="!oneDayMode ? 'container-fluid w-100 pb-3' : ''">
    <navbar v-if="!oneDayMode" :title="$t('daily_summary.generation_title')"/>
    <form class="no-margin" @submit.prevent="generateDailySummaries" @reset.prevent="onReset">
        <div class="container p-0 py-2">
            <div class="row" v-if="!oneDayMode">
                <div class="col-sm-6">
                    <span class="span-title">{{ $t('trip_list.road_sec_from') }} - {{ $t('daily_summary.date') }}</span>
                    <input
                        id="fromDate"
                        v-model="fromDate"
                        type="date"
                        class="form-control form-control-sm"
                    />
                </div>
                <div class="col-sm-6">
                    <span class="span-title">{{ $t('trip_list.road_sec_to') }} - {{ $t('daily_summary.date') }}</span>
                    <input
                        id="date"
                        v-model="toDate"
                        type="date"
                        class="form-control form-control-sm"
                    />
                </div>
            </div>
            <div class="row" v-if="oneDayMode">
                <div class="col-sm-6">
                    <span class="span-title">{{ $t('daily_summary.date') }}</span>
                    <input
                        id="date"
                        v-model="singleDate"
                        type="date"
                        class="form-control form-control-sm"
                    />
                </div>
            </div>
            <div class="row" v-if="!oneDayMode">
                <div class="col-sm-6">
                    <open-contract-filter
                        :from="fromDate"
                        :to="toDate"
                        :show-title="true"
                        :show-company="false"
                        @contract-selected="setContract"
                    />
                </div>
            </div>
            <div class="col-sm-12 button-container">
                <button
                    v-if="!oneDayMode"
                    type="submit"
                    class="btn btn-primary form-button"
                    :disabled="!fromDate||!toDate"
                >
                    {{ $t('daily_summary.generate') }}
                </button>
                <button
                    v-if="oneDayMode"
                    type="submit"
                    class="btn btn-primary form-button"
                    :disabled="!singleDate"
                >
                    {{ $t('daily_summary.generate') }}
                </button>
                <button
                    type="reset"
                    class="btn btn-danger form-button"
                >
                    {{ $t('ins_report.clear') }}
                </button>
            </div>
        </div>
    </form>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from '../mixins/TimeUtils'
import OpenContractFilter from "../contract/OpenContractFilter";
import Navbar from "@/components/utils/Navbar";
import {inject} from "vue";

export default {
    name: 'ContractTripSummaryGenerator',
    components: {Navbar, OpenContractFilter},
    mixins: [restApi, timeUtils],
    props: {
        oneDayMode: {
            type: Boolean,
            default: false
        },
        contractObject: {
            type: Object,
            default: null
        },
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            fromDate: null,
            toDate: null,
            singleDate: null,
            contract: null
        }
    },

    mounted() {
        if(this.contractObject && this.contractObject.id) {
            this.setContract(this.contractObject)
        }
    },

    methods: {
        generateDailySummaries: function () {
            let params = {}
            if (this.fromDate) {
                params.from = this.fromDate
            }
            if (this.toDate) {
                params.to = this.toDate
            }
            if (this.fromDate > this.toDate) {
                this.showAlert(this.$t('daily_summary.invalid_date'))
                return undefined
            }
            if (this.contract) {
                params.contract = this.contract.id
            }
            if(this.singleDate) {
                params.single_date = this.singleDate
            }
            this.loading = true
            this.restFetchParams(this.oneDayMode ? this.generateContractDailyTripSummaryUrl + '/single' : this.generateContractDailyTripSummaryUrl, params, this.success, this.fail)
        },
        success: function () {
            this.loading = false
            this.showAlert(this.$t('daily_summary.generation_success'), 'success')
            this.$emit("closeModal")
        },
        fail: function () {
            this.loading = false
            this.showAlert(this.$t('daily_summary.generation_failed'))
        },
        onReset: function () {
            this.fromDate = null
            this.toDate = null
            this.singleDate = null
        },
        setContract: function (contract) {
            this.contract = contract
        }
    }
}
</script>
